module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112921-DealerDraft-Infinity-3Modern.6659afca.jpeg";